<div class="d-flex align-items-center flex-column justify-content-center my-4">
    <app-image-by-facility src="empty" alt="NoData" width="290" height="190" />
    <h3 class="mat-subtitle-2 mt-3">
        No data matching the filter
        <span class="fw-bold">{{ filter ? ' - ' + filter : '' }}</span>
    </h3>
</div>
